import { omit } from '../../../helpers/object.helpers';
import {
  ElementCategoryID,
  IElementCategory,
} from '../../../models/element-categories.model';
import { DEFAULT_QUANTITY_PROPERTIES } from '../../../models/element-quantities.model';
import { Orientation } from '../../../models/orientation.model';
import { systemElementCategoryProperties } from '../common-element-category-properties.model';

export const beam: IElementCategory = {
  id: ElementCategoryID.Beam,
  name: 'Beam',
  orientation: Orientation.Horizonal,
  defaultSelectedQuantity: 'mass',
  properties: systemElementCategoryProperties,
  getQuantityProperties: () =>
    omit(DEFAULT_QUANTITY_PROPERTIES, 'density', 'mass', 'fill'),
  getElementPropertySelectionByProductId: () => undefined,
};
